import { useGetStaffUsersQuery } from '@/services/api/userService';

interface CheckInAuthorProps {
  userId: string;
}

export const CheckInAuthor = ({ userId }: CheckInAuthorProps) => {
  const { data: staffUsers = [], isLoading } = useGetStaffUsersQuery();

  if (isLoading) {
    return <p className="text-xs text-gray-500 truncate">Loading user...</p>;
  }

  const user = staffUsers.find((u) => String(u.id) === userId);

  if (!user) {
    // It's possible the user is no longer active, so we don't want to break the UI
    return null;
  }

  const name = `${user.first_name} ${user.last_name}`.trim();

  return <p className="text-xs text-gray-500 truncate">Logged by {name}</p>;
};
